import { useEffect, useState } from 'react';
import { searchOnEnter } from '../../components/searchOnEnter';
import MetaData from '../../layouts/MetaData';
import  HRSidebar from '../../components/HR/HRSidebar';
import HRTopBar from '../../components/HR/HRTopbar';
import { getHrProfile, patientDeActivate, patientActivate } from '../../actions/adminActions';
import { getHRPatients} from '../../actions/HRActions';
import { useSelector, useDispatch } from 'react-redux';
import folderImg from '../../assets/Images/folder.png';
import Loader from '../../layouts/Loader';
import { Link } from 'react-router-dom';
import { Table, DropdownButton, Dropdown, ProgressBar } from 'react-bootstrap';
import moment from 'moment';
import IncludeDeactivatedToggle from '../../components/IncludeDeactivatedToggle';
import { useAlert} from 'react-alert';
import './leadActionsMenu.css';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh } from '../../components/SortableTable';
import { PATIENT_LIST_SORT_COLUMNS } from '../Staff/StaffPatients';
import DeactivatePatientModal from '../../components/DeactivatePatientModal';
import { isDeceasedPatient } from '../../utils/deactivationReasons';
import { formatDate, formatDob } from '../../utils/dateFormat';



const HRPatientsList = () => {

    const alert = useAlert();
    const dispatch = useDispatch();
    let compliantStatus; // variable to store compliant status of patient

    const { isAuthenticated, user} = useSelector(state => state.auth);
    const { loading, error, hrpatients} = useSelector(state => state.hrPatients);
    const tableSort = useSortableTable(hrpatients, { id: 'nurse.rpmPatients', columns: PATIENT_LIST_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });

    const [query, setQuery] = useState("");
    const keys = ["firstname", "lastname", "DOB", "email", "phone1"];
    const { hrProfile } = useSelector(state => state.hrprofile);
    const [includeDeactivated, setIncludeDeactivated] = useState(false);

    let id = user._id;
    let docId = hrProfile?.assigned_doctor_id?._id;

    useEffect(() => {
		if(error) {
			alert.error(error);
		}

        dispatch(getHrProfile(id));

        let getDrId = localStorage.getItem('doctorId');
         
        if(getDrId){
         dispatch(getHRPatients(getDrId, includeDeactivated));
        } else {
         dispatch(getHRPatients(docId, includeDeactivated));   
        }

	}, [dispatch, alert, error, id, isAuthenticated, docId, includeDeactivated])


    const reloadPatients = () => { const g = localStorage.getItem('doctorId'); if(g){ dispatch(getHRPatients(g, includeDeactivated)); } else { dispatch(getHRPatients(docId, includeDeactivated)); } };
    const [deactivateTarget, setDeactivateTarget] = useState(null);
    const leadDeactivate = (patient) => setDeactivateTarget(patient);
    const confirmLeadDeactivate = async (deactivation) => { const patient = deactivateTarget; setDeactivateTarget(null); await dispatch(patientDeActivate(patient._id, deactivation)); alert.success('Patient deactivated'); reloadPatients(); };
    const leadReactivate = async (patient) => { if (isDeceasedPatient(patient)) { alert.error('This patient is marked deceased. Only a Super Admin can reactivate (Inactive Patients list).'); return; } if(window.confirm('Reactivate this profile (' + (patient?.lastname||'') + ', ' + (patient?.firstname||'') + ')? The person will be able to log in again.')){ await dispatch(patientActivate(patient._id)); alert.success('Patient reactivated'); reloadPatients(); } };
    function calculateCompliancyStatus(date) {  
        var m = moment(date);
        var today = moment().startOf('day');
        var days = moment.duration(today - m).asDays();

        switch(true){
            case (days >= 0 && days < 3):
                compliantStatus = 'compliant'
                break;

            case (days >= 3 && days <= 7):
                compliantStatus = "mostLikelyCompliant"
                break;

            case (days >= 8 && days <= 20):
                compliantStatus = "notLikelyCompliant"
                break;

            case (days >= 8 && days <= 31):
                compliantStatus = "nonCompliant"
                break;
            
            default:
                compliantStatus = 'nonCompliant'
                break;
        }
    }


    const setDoctorInLocalStorage = (value) => {
         localStorage.setItem("doctorId", value);
         dispatch(getHRPatients(value, includeDeactivated));

    }

  return <>
      <MetaData title="Patients List" />
            <HRSidebar />
            
            <section className="home-section">
                {/* TopBar */}  
                <HRTopBar />


                {loading ? <Loader /> : <>
                    <div className="shadow-lg p-3 mb-5 mr-4 ml-4 bg-white rounded">        
                        <div className="home-content">
                            <div className="container">
                                <div className="row-display">
                                <h5 style={{color: '#004aad'}}>
                                    <strong>RPM Patients </strong>
                                    <p><small>RPM Patients of your assigned doctor will be shown below.</small></p>
                                </h5>

                                <div> 
                                        <Link to="/Nurse/Dashboard" className="btn btn-secondary btn-sm"><i className='bx bx-arrow-back' ></i></Link> &nbsp;
                                        &nbsp;&nbsp;
                                        {user?.role === 'HrLead' ? (<Link to="/Nurse/Add_New_Patient" className="edit-pill">+ Add New Patient</Link>) : null} 
                                </div>
                                </div>
                            
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="row-display">    
                                        <input 
                                                type="text" 
                                                className="form-control mt-2"
                                                onChange={e => setQuery(e.target.value)}
                                                onKeyDown={searchOnEnter(setQuery)}
                                                placeholder="Search Patient ... "
                                                style={{width: '180px', height: '40px'}}
                                            /> 

                                            &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <IncludeDeactivatedToggle checked={includeDeactivated} onChange={setIncludeDeactivated} />
                                    </div>

                                    <div className="col-md-3">
                                        <label className="profile-label">Select Your Working Doctor : </label><br />
                                        <select className="form-control" 
                                            value={localStorage.getItem('doctorId')}
                                            onChange={e => setDoctorInLocalStorage(e.target.value)}>
                                            <option value="61f99c89323eaa15a61a7976">Pier Frank, MD</option>
                                            <option value="640f5c5e2c774825162cba6e">Frank Boateng, MD</option> 
                                            <option value="641230ef4ede893bec43d593">Ruth Lambe</option>
                                        </select>
                                    </div>
                                  </div>
                                </div>
                            <br />
                                
                                {hrpatients?.length > 0 ? (<>
                                <div className="container-fluid col-md-12">
                                    <>
                                        <Table responsive className="table table-sm table-striped">
                                        <thead align="center">
                                            <tr>
                                            <SortableTh sortKey="emrId" sort={tableSort}>EHR-ID</SortableTh>
                                            <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                            <SortableTh sortKey="dob" sort={tableSort}>DOB</SortableTh>
                                            <th>Device Status</th>
                                            <SortableTh sortKey="status" sort={tableSort}>Acc Status</SortableTh>
                                            <SortableTh sortKey="provider" sort={tableSort} className="text-nowrap">Provider</SortableTh>
                                            <th>Compliancy Status</th>
                                            <th>Last Reading </th>
                                            <SortableTh sortKey="consent" sort={tableSort}>Consent Program</SortableTh>
                                            <th>Actions</th> 
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {tableSort.rows.filter(item => keys.some(key => item[key]?.toLowerCase().includes(query))).map((patient, index) => (  
                                            <tr key={index}>
                                            <td>{patient?.emrId || 'N/A'}</td>

                                        {patient?.block === false ? <td>
                                            <Link style={{textDecoration: 'none', color: 'dodgerblue', fontWeight: 'bold'}} 
                                                to={{ pathname: "/Nurse/Patient/Profile", state: {patientid: patient?._id }}}>
                                                    {patient?.lastname}, {patient?.firstname}
                                            </Link>
                                        </td> : <td>{patient?.lastname}, {patient?.firstname} </td> }
                                         
                                        
                                        <td> {formatDob(patient?.DOB)} <p>
                                            {patient?.gender}</p>
                                        </td>
                                                    
                                        <td>{patient?.batterySignals?.sig >= 0 && patient?.batterySignals?.sig <= 10 ? 
                                                <text style={{color: 'red', fontWeight: 'bold'}}>Weak</text> : patient?.batterySignals?.sig > 10 && patient?.batterySignals?.sig <= 20 ? 
                                                <text style={{color: 'orange', fontWeight: 'bold'}}>Medium</text> : patient?.batterySignals?.sig > 20 ? <text style={{color: 'green', fontWeight: 'bold'}}>Strong</text> : '--'} 

                                            {patient?.batterySignals?.sig ? <ProgressBar striped variant="info" now={patient?.batterySignals?.bat} label={`${patient?.batterySignals?.bat}%`} /> : '--'}
                                        </td>
                                
                                        {patient?.block === false ? <td>
                                            <span style={{color: 'green'}}>Active</span>
                                            </td> : <td><span style={{color: 'red'}}>Inactive</span>
                                        </td>}

                                        {patient?.assigned_doctor_id ? <>
                                            <td className="text-nowrap" style={{color: '#23408e'}}>{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                            </> : <>
                                            <td><span style={{color: 'red'}}>Not Assigned</span></td>
                                        </>}
 
                                        {calculateCompliancyStatus(moment(patient?.lastReading))}    
                                        
                                        <td>
                                            {patient?.lastReading ? 
                                                compliantStatus === 'compliant' ? <p style={{color: 'green', fontWeight: 'bold'}}>
                                                    Compliant</p> : compliantStatus === 'mostLikelyCompliant' ? <p style={{color: '#F95800', fontWeight: 'bold'}}>
                                                        Most Likely Compliant</p> : compliantStatus === 'notLikelyCompliant' ? <p style={{color: 'dodgerblue', fontWeight: 'bold'}}>
                                                            Not Likely Compliant</p> : compliantStatus === 'nonCompliant' ? <p style={{color: 'red', fontWeight: 'bold'}}>
                                                            Non Compliant</p> : null : '--'}
                                        </td>

                                        <td><span style={{fontWeight: 'bold'}}>{patient?.lastReading ? formatDate(patient?.lastReading) : '--'}</span>
                                        
                                        </td>

                                        <td>{patient?.patientType}</td> 


                                            <td>
                                            <DropdownButton id="dropdown-basic-button" variant="Light" align="end" menuClassName="leadActionsMenu" >
                                                <Dropdown.Item>
                                                    <Link className="link" to={{ pathname: "/Nurse/Patient/Profile", state: {patientid: patient?._id}}}>View Profile</Link>
                                                </Dropdown.Item>
                                                                                            {patient?.block === false ? (<Dropdown.Item onClick={() => leadDeactivate(patient)}>Deactivate Profile</Dropdown.Item>) : null}
                                                {patient?.block === true ? (<Dropdown.Item onClick={() => leadReactivate(patient)}>Reactivate Profile</Dropdown.Item>) : null}
                                            </DropdownButton>
                                            </td>
                                        </tr> 
                                        ))}
                                         
                                        </tbody>
                                        </Table>    
                                    </>                      
                            </div>
                        </> ) : <>
                        <div>   
                                           
                        <img src={folderImg} className="no-record-found-img" alt="img" />
                        <p className="doctor-specilizations">No Patient Assigned Yet...</p>                            
                                    </div>
                                </> }
                            </div>
                        </div>
                    </div>
                </>
                    }
                <DeactivatePatientModal
                show={!!deactivateTarget}
                patient={deactivateTarget}
                onCancel={() => setDeactivateTarget(null)}
                onConfirm={confirmLeadDeactivate}
            />
            </section>
  </>;
};

export default HRPatientsList;
